import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-2">Page not found</h1>
        <p className="text-muted-foreground mb-4">
          The page you were looking for does not exist.
        </p>
        <Link className="btn-primary" to="/app/inbox">Go to inbox</Link>
      </div>
    </div>
  );
}
